import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Page from "src/components/Page";
import { useLocation, useNavigate } from "react-router-dom";
import {
  X,
  Search,
  Download,
  UploadCloud,
  Copy,
  DownloadCloud,
  Edit,
  Eye
} from "react-feather";

import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import moment from "moment";
import { getInvoiceListApi, getInvoiceListZipApi, getCityListByStateApi, getStateListApi, updateInvoiceStatusApi } from "src/api/invoiceApi";
import { notification } from "src/utils/messages";
import { getProductApi } from "src/api/productApi";
import { invoiceFilterFields, invoiceToTypeOptions, IsNotValue } from "src/constant/variable";
import { handleDownload } from "src/utils/common";
import { Routes } from "src/constant/api_url";

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const cancelModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [page, setPage] = useState(1);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [invoiceListData, setInvoiceListData] = useState([]);
  const [filterData, setFilterData] = useState(invoiceFilterFields);
  const [previousFilterData, setPreviousFilterData] = useState(invoiceFilterFields);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [cancelConfirmationModal, setCancelConfirmationModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const getStateList = async () => {
    try {
      const resp = await getStateListApi();
      if (resp.status == 1) {
        setStateList(resp.data);
      }
    } catch (error) { }
  };

  const getCityList = async (stateId) => {
    try {
      const resp = await getCityListByStateApi({ state_id: stateId });
      if (resp.status == 1) {
        setCityList(resp.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getStateList();
  }, []);

  const getInvoiceList = async (data) => {
    const resp = await getInvoiceListApi({
      page: page,
      per_page: rowPerPage,
      i_to_type: data?.i_to_type,
      i_type: data?.i_type,
      start_date: data?.start_date,
      end_date: data?.end_date,
      search: data?.search,
      state_id: data?.state_id,
      city_id: (loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 0))
        ? data?.city_id
        : loginUser.city_id,
      pagination: true
    });
    if (resp.status == 1) {
      setInvoiceListData(resp?.data?.data);
      setTotalRows(resp?.data.count);
    } else {
      setInvoiceListData([]);
      setTotalRows(0);
    }
  };

  const handleDownloadZip = async () => {
    const resp = await getInvoiceListZipApi({
      i_to_type: filterData?.i_to_type,
      i_type: filterData?.i_type,
      start_date: filterData?.start_date,
      end_date: filterData?.end_date,
      search: filterData?.search,
      state_id: filterData?.state_id,
      city_id: filterData?.city_id
    });
    if (resp.status == 1) {
      handleDownload(resp?.data?.zip_url, resp?.data?.file_name);
    }
  };

  const expo_columns = [
    { label: "Invoice number", key: "invoice_no" },
    { label: "Invoice date", key: "i_date" },
    { label: "Tax applicable", key: "tax_applicable" },
    { label: "Tax type", key: "tax_type_text" },
    { label: "Company Name", key: "c_display_name" },
    { label: "GSTIN", key: "c_company_gst_no" },
    { label: "PAN", key: "c_company_pan_no" },
    { label: "Billing address 1", key: "c_customer_address" },
    { label: "Item name", key: "i_p_name" },
    { label: "Item description", key: "i_d_description" },
    { label: "HSN / SAC", key: "i_d_hsn_code" },
    { label: "Quantity", key: "i_d_qty" },
    { label: "Rate", key: "i_d_cost" },
    { label: "Item discount amount", key: "i_d_discount_amt" },
    { label: "Item total amount(without Tax)", key: "i_d_sub_amt" },
    { label: "Tax category", key: "tax_category" },
    { label: "CGST rate(%)", key: "i_d_cgst_per" },
    { label: "CGST amount", key: "i_d_cgst_amt" },
    { label: "SGST rate(%)", key: "i_d_sgst_per" },
    { label: "SGST amount", key: "i_d_sgst_amt" },
    { label: "IGST rate(%)", key: "i_d_igst_per" },
    { label: "IGST amount", key: "i_d_igst_amt" },
    { label: "Item tax amount", key: "item_tax_amt" },
    { label: "Item total amount(with Tax)", key: "i_d_total_amt" },
    { label: "Basic amount", key: "i_subtotal_amt" },
    { label: "Total Item discount", key: "i_discount_amt" },
    { label: "Total CGST", key: "i_cgst_amt" },
    { label: "Total SGST", key: "i_sgst_amt" },
    { label: "Total IGST", key: "i_igst_amt" },
    { label: "Total tax", key: "total_tax_amt" },
    { label: "Invoice amount", key: "i_total_amt" },
    { label: "City", key: "city_name" },
    { label: "Generated Date", key: "created_at" },
    { label: "Status", key: "status_text" }
  ];

  const handleExportCSV = async () => {
    const resp = await getInvoiceListApi({
      pagination: false,
      i_to_type: filterData?.i_to_type,
      i_type: filterData?.i_type,
      start_date: filterData?.start_date,
      end_date: filterData?.end_date,
      search: filterData?.search,
      state_id: filterData?.state_id,
      city_id: filterData?.city_id,
      download_csv: true
    });

    if (resp.status == 1) {
      const productResp = await getProductApi({ i_p_type: -1 });
      const products = productResp.status == 1 ? productResp.data : [];

      const flattenedData = [];
      resp?.data?.data?.forEach((row) => {
        const invoice_no = `${row.i_prefix}${row.i_no}`;
        const tax_applicable = row.gst_type === 1 || row.gst_type === 2 ? "Yes" : "No";
        const tax_type_text =
          row.gst_type === 2 ? "Local" : row.gst_type === 1 ? "Interstate" : "Non GST";
        const total_tax_amt = (
          Number(row.i_igst_amt || 0) +
          Number(row.i_sgst_amt || 0) +
          Number(row.i_cgst_amt || 0)
        ).toFixed(2);
        const status_text = row?.status == 1 ? "Cancelled" : "Active";

        if (row.invoice_product && row.invoice_product.length > 0) {
          row.invoice_product.forEach((item, itemIndex) => {
            const product = products.find((p) => p.i_p_id === item.i_p_id);
            const item_tax_amt = (
              Number(item.i_d_igst_amt || 0) +
              Number(item.i_d_sgst_amt || 0) +
              Number(item.i_d_cgst_amt || 0)
            ).toFixed(2);
            const tax_category =
              row.gst_type === 0
                ? "No GST"
                : `GST @ ${Number(item.i_d_igst_per || 0) +
                Number(item.i_d_cgst_per || 0) +
                Number(item.i_d_sgst_per || 0)
                }%`;

            flattenedData.push({
              ...row,
              ...item,
              invoice_no: itemIndex === 0 ? invoice_no : "",
              i_date: itemIndex === 0 ? row.i_date : "",
              tax_applicable: itemIndex === 0 ? tax_applicable : "",
              tax_type_text: itemIndex === 0 ? tax_type_text : "",
              c_company_gst_no: itemIndex === 0 ? row.c_company_gst_no : "",
              c_company_pan_no: itemIndex === 0 ? row.c_company_pan_no : "",
              c_customer_address: itemIndex === 0 ? row.c_customer_address : "",
              i_p_name: product ? product.i_p_name : "",
              item_tax_amt,
              tax_category,
              total_tax_amt,
              status_text: itemIndex === 0 ? status_text : ""
            });
          });
        } else {
          flattenedData.push({
            ...row,
            invoice_no,
            tax_applicable,
            tax_type_text,
            total_tax_amt,
            status_text
          });
        }
      });

      downloadCSV(flattenedData);
    }
  };

  const downloadCSV = (data) => {
    const csvContent =
      `${expo_columns?.map((column) => column.label).join(",")}\n` +
      `${data
        ?.map((row) =>
          expo_columns
            ?.map((column) => {
              let value =
                row[column.key] == undefined ||
                  row[column.key] === null ||
                  row[column.key] === "null"
                  ? ""
                  : row[column.key].toString();

              return `"${value.replace(/"/g, '""')}"`;
            })
            .join(",")
        )
        .join("\n")}`;

    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", blobUrl);
    link.setAttribute(
      "download",
      !IsNotValue.includes(filterData?.start_date) && !IsNotValue.includes(filterData?.end_date)
        ? `LVB-sales-details-${filterData.start_date}_${filterData.end_date}.csv`
        : "LVB-sales-details.csv"
    );

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  };

  const columns = [
    { name: "No", selector: (row, index) => row?.i_id, width: "70px" },
    {
      name: "Invoice No",
      wrap: true,
      cell: (row) => (
        <span title={`${row?.i_prefix}${row?.i_no}`}>{`${row?.i_prefix}${row?.i_no}`}</span>
      )
    },
    {
      name: "Company Name",
      wrap: true,
      width: "150px",
      cell: (row) => <span title={row?.c_company_name}>{row?.c_company_name}</span>
    },
    {
      name: "Customer Name",
      wrap: true,
      width: "150px",
      cell: (row) => <span title={row?.c_name}>{row?.c_name}</span>
    },
    {
      name: "Mobile",
      wrap: true,
      width: "150px",
      cell: (row) => <span title={row?.c_mono}>{row?.c_mono}</span>
    },
    {
      name: "Date",
      wrap: true,
      width: "120px",
      cell: (row) => <span title={row?.i_date}>{row?.i_date}</span>
    },
    {
      name: "Company GST Type",
      wrap: true,
      cell: (row) => (
        <span title={row?.company_gst_type == 0 ? "Non GST" : "GST"}>
          {row?.company_gst_type == 0 ? "Non GST" : "GST"}
        </span>
      )
    },
    {
      name: "Created By",
      wrap: true,
      width: "120px",
      cell: (row) => <span title={row?.created_by_name}>{row?.created_by_name}</span>
    },
    {
      name: "City",
      wrap: true,
      width: "120px",
      cell: (row) => <span title={row?.city_name}>{row?.city_name}</span>
    },
    {
      name: "Generated Date",
      wrap: true,
      width: "180px",
      cell: (row) => (
        <span title={moment(row?.created_at).format("DD-MM-YYYY hh:mm A")}>
          {moment(row?.created_at).format("DD-MM-YYYY hh:mm A")}
        </span>
      )
    },
    {
      name: "Status",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <span
          style={{
            color: row?.status == 1 ? "red" : "green",
            fontWeight: "bold"
          }}
        >
          {row?.status == 1 ? "Cancelled" : "Active"}
        </span>
      )
    },
    {
      name: "Actions",
      wrap: true,

      width: "150px",
      selector: (row) => (
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="View Invoice">
            <IconButton
              className="icon-btn-zero"
              onClick={() => {
                window.open(`${Routes.API_HOSTNAME}invoice-pdf/${row?.i_file_name}`, "_blank");
                // navigate("/citywallethistory", { state: row });
                // toggleWalletHistoryModel();
              }}
            >
              <Eye size={15} color="blue" />
            </IconButton>
          </Tooltip>
          {(loginUser?.u_type == 0 ||
            (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1) ||
            (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)) && (
              <Tooltip title="Edit Invoice">
                <IconButton
                  className="icon-btn-zero"
                  onClick={() => {
                    // i_type: location.pathname == "/quotation-invoice"
                    //   ? 0
                    //   : location.pathname == "/paid-invoice"
                    //     ? 1
                    //     : -1;
                    navigate(
                      location.pathname == "/quotation-invoice"
                        ? "/edit-quotation"
                        : "/edit-invoice",
                      {
                        state: {
                          mode: "edit",
                          data: row
                        }
                      }
                    );
                  }}
                >
                  <Edit size={15} color="orange" />
                </IconButton>
              </Tooltip>
            )}
          {console.log(row, "row")}
          <Tooltip title="Download Invoice">
            <IconButton
              className="icon-btn-zero"
              onClick={() => {
                handleDownload(
                  `${Routes.API_HOSTNAME}invoice-pdf/${row?.i_file_name}`,
                  row?.i_file_name
                );
                // navigate("/citywallethistory", { state: row });
                // toggleWalletHistoryModel();
              }}
            >
              <DownloadCloud size={15} color="green" />
            </IconButton>
          </Tooltip>
          {(loginUser?.u_type == 0 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)) &&
            (<Tooltip title="Cancel Invoice">
              <IconButton
                className="icon-btn-zero"
                disabled={row?.status == 1}
                onClick={() => {
                  setSelectedInvoice(row);
                  setCancelConfirmationModal(true);
                }}
              >
                <X size={15} color={row?.status == 1 ? "gray" : "red"} />
              </IconButton>
            </Tooltip>)
          }
          {/* <Tooltip title="Copy Invoice">
            <IconButton
              className="icon-btn-zero"
              // onClick={() => {
              //   navigate("/citywallethistory", { state: row });
              //   // toggleWalletHistoryModel();
              // }}
            >
              <Copy size={15} />
            </IconButton>
          </Tooltip> */}
        </Stack>
      )
    }
  ];

  useEffect(() => {
    setFilterData({
      ...invoiceFilterFields,
      i_type:
        location.pathname == "/quotation-invoice"
          ? 0
          : location.pathname == "/paid-invoice"
            ? 1
            : -1
    });
    setInvoiceListData([]);
  }, [location.pathname]);

  useEffect(() => {
    if (filterData?.i_type != -1) getInvoiceList(filterData);
  }, [page, rowPerPage, filterData?.i_type]);

  const ExpandableRow = ({ data }) => {
    return (
      <Box px={2} py={1} bgcolor="#fafafa">
        <Grid container spacing={1}>
          {[
            { label: "Invoice No", value: `${data.i_prefix}${data.i_no}` },
            { label: "Company Name", value: data.c_company_name },
            { label: "Customer Name", value: data.c_name },
            { label: "Mobile", value: data.c_mono },
            { label: "Date", value: data.i_date },
            { label: "Company GST Type", value: data?.company_gst_type == 0 ? "Non GST" : "GST" },
            { label: "Amount", value: `₹ ${data.i_total_amt}` },
            { label: "Created By", value: data.created_by_name },
            { label: "Status", value: data?.status == 1 ? "Cancelled" : "Active" }
          ]?.map((item) => (
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography>
                  {item?.label} : {item?.value || "-"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ mt: 1.5 }} />
      </Box>
    );
  };

  const isFilterValid = (type) => {
    const keys = ["i_to_type", "start_date", "end_date", "search", "state_id", "city_id"];

    if (type === "search") {
      return keys.some((key) => filterData?.[key] !== previousFilterData?.[key]);
    } else if (type === "clear") {
      return keys.some((key) => {
        return previousFilterData?.[key] != invoiceFilterFields[key];
      });
    }

    return false;
  };

  return (
    <>
      <Page title="Product History">
        <Container maxWidth="md">
          <Grid container spacing={1} alignItems="center" sx={{ marginBottom: 2 }}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <Typography variant="h4">
                {location?.pathname === "/paid-invoice"
                  ? "Paid Invoice"
                  : location?.pathname === "/quotation-invoice"
                    ? "Quotation Invoice"
                    : ""}
              </Typography>
            </Grid>
          </Grid>
          <Card className="p-20">
            <Grid container spacing={2} alignItems="end">
              <Grid item xs={12} md={4}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Date Range
                </Typography>
                <Stack direction="row" spacing={1}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filterData.start_date != null
                          ? moment(filterData.start_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setFilterData({
                          ...filterData,
                          start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        filterData.end_date != null
                          ? moment(filterData.end_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(newDate) => {
                        setFilterData({
                          ...filterData,
                          end_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                        });
                      }}
                      renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              {(loginUser.u_type == 0 || (loginUser.u_type == 2 && loginUser.p_user_id == 0)) &&
                (<Grid item xs={12} md={4}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Location Filter
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <Box sx={{ flex: 1 }}>
                      <Select
                        isClearable
                        placeholder="State"
                        options={stateList?.map((s) => ({
                          label: s?.state_name,
                          value: s?.state_id
                        }))}
                        value={
                          stateList
                            ?.map((s) => ({
                              label: s?.state_name,
                              value: s?.state_id
                            }))
                            ?.find((option) => option.value == filterData.state_id) || null
                        }
                        onChange={(selectedOption) => {
                          setFilterData({
                            ...filterData,
                            state_id: selectedOption ? selectedOption.value : "",
                            city_id: ""
                          });
                          setCityList([]);
                          if (selectedOption) {
                            getCityList(selectedOption.value);
                          }
                        }}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Select
                        isClearable
                        placeholder="City"
                        options={cityList?.map((c) => ({
                          label: c?.city_name,
                          value: c?.city_id
                        }))}
                        value={
                          cityList
                            ?.map((c) => ({
                              label: c?.city_name,
                              value: c?.city_id
                            }))
                            ?.find((option) => option.value == filterData.city_id) || null
                        }
                        onChange={(selectedOption) => {
                          setFilterData({
                            ...filterData,
                            city_id: selectedOption ? selectedOption.value : ""
                          });
                        }}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </Box>
                  </Stack>
                </Grid>)
              }

              <Grid item xs={12} md={2}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Invoice To
                </Typography>
                <Select
                  options={[{ label: "All", value: -1 }, ...invoiceToTypeOptions]}
                  value={[{ label: "All", value: -1 }, ...invoiceToTypeOptions].find(
                    (c) => c.value === filterData.i_to_type
                  )}
                  onChange={(e) => setFilterData({ ...filterData, i_to_type: e.value })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999
                    })
                  }}
                />
              </Grid>

              {(loginUser?.u_type == 0 ||
                (loginUser?.u_type == 0 && loginUser?.is_subadmin == 1) ||
                (loginUser?.u_type == 2 && loginUser?.p_user_id == 1)) && (
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => {
                        navigate(
                          location.pathname == "/quotation-invoice" ? "/add-quotation" : "/add-invoice",
                          {
                            state: {
                              mode: "add",
                              data: {
                                i_type:
                                  location.pathname == "/quotation-invoice"
                                    ? 0
                                    : location.pathname == "/paid-invoice"
                                      ? 1
                                      : -1
                              }
                            }
                          }
                        );
                      }}
                    >
                      {location?.pathname === "/paid-invoice"
                        ? "Create Invoice"
                        : location?.pathname === "/quotation-invoice"
                          ? "Create Quotation"
                          : "Create"}
                    </Button>
                  </Grid>
                )}

              <Grid item xs={12} sx={{ mt: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <TextField
                    size="small"
                    label="Search by Company, Customer or Mobile"
                    name="search"
                    autoComplete="off"
                    value={filterData.search || ""}
                    onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
                    sx={{ flex: 1 }}
                  />
                  <Button
                    variant="contained"
                    title="Search"
                    className="custom_icon_style"
                    onClick={() => {
                      if (isFilterValid("search")) {
                        setPreviousFilterData(filterData);
                        getInvoiceList(filterData);
                      }
                    }}
                  >
                    <Search size={16} />
                  </Button>

                  <Button
                    variant="contained"
                    title="Clear"
                    className="custom_icon_style"
                    onClick={() => {
                      if (isFilterValid("clear")) {
                        const filterData = {
                          ...invoiceFilterFields,
                          i_type:
                            location.pathname == "/quotation-invoice"
                              ? 0
                              : location.pathname == "/paid-invoice"
                                ? 1
                                : -1
                        };
                        setPreviousFilterData(invoiceFilterFields);
                        setFilterData(filterData);
                        getInvoiceList(filterData);
                      }
                    }}
                  >
                    <X size={16} />
                  </Button>

                  <Button
                    variant="contained"
                    title={`Download ${location?.pathname === "/paid-invoice"
                      ? "Invoice"
                      : location?.pathname === "/quotation-invoice"
                        ? "Quotation"
                        : ""
                      } Zip`}
                    className="custom_icon_style"
                    onClick={handleDownloadZip}
                  >
                    <DownloadCloud size={16} />
                  </Button>

                  <Button
                    variant="contained"
                    title={`Export ${location?.pathname === "/paid-invoice"
                      ? "Paid"
                      : location?.pathname === "/quotation-invoice"
                        ? "Quotation"
                        : ""
                      } Invoice CSV`}
                    className="custom_icon_style"
                    onClick={handleExportCSV}
                  >
                    <UploadCloud size={16} />
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Card>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
              columns={columns}
              expandableRows
              expandOnRowClicked
              expandableRowsComponent={ExpandableRow}
              data={invoiceListData != null ? invoiceListData : []}
            />
          </Card>
        </Container>
      </Page>

      <Modal open={cancelConfirmationModal} onClose={() => setCancelConfirmationModal(false)}>
        <Box sx={cancelModalStyle}>
          <Typography variant="h6" textAlign="center">
            Are you sure you want to cancel this invoice?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="contained"
              onClick={async () => {
                try {
                  const resp = await updateInvoiceStatusApi({
                    status: 1,
                    i_id: selectedInvoice?.i_id
                  });
                  if (resp.status == 1) {
                    notification({ type: "success", message: resp.message })();
                    getInvoiceList(filterData);
                  } else {
                    notification({ type: "error", message: resp.message })();
                  }
                } catch (error) {
                  notification({ type: "error", message: "Something went wrong" })();
                }
                setCancelConfirmationModal(false);
              }}
            >
              Yes, Cancel
            </Button>
            <Button variant="outlined" onClick={() => setCancelConfirmationModal(false)}>
              No
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
